import { encryptAES, decryptAES } from '@/utils/encryption/crypto-js.js';
import { encryptRSA, decryptRSA } from '@/utils/encryption/jsencrypt.js';
/**
 * @description: 唯一值GUID
 * @param {type}
 * @return:
 * @Modification history:
 * @Author: zhuzhaoyang
 * @LastEditTime: Do not edit
 * @LastEditors: Do not edit
 * @Date: 2019-08-30 18:06:40
 */
export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
/**
 * @FunctionName: 获取路径参数
 * @param {*} urlStr
 * @return {*}
 * @Modification history:
 * @Description:
 */
export function getRequestParam(urlStr:string) {
  const theRequest:any = {};
  const url = decodeURI(urlStr);
  if (url.indexOf('?') !== -1) {
    const str = url.substr(url.indexOf('?') + 1, url.length - 1);
    const strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  } else {
    return {};
  }
  return theRequest;
}
/**
 * @FunctionName: 字符串补0
 * @param {*} value
 * @param {*} targetLength 默认16位数
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-10-29 14:59:00
 * @Modification history:
 * @Description:
 */
export function strLastZero(value:any, targetLength = 16) {
  let strVal = value.toString();
  if (strVal.length < targetLength) {
    const index = targetLength - strVal.length;
    // 补0
    for (let i = 0; i < index; i++) {
      strVal += '0';
    }
  }
  return strVal;
}
/**
 * @FunctionName: 字符串转ASCLL
 * @param {*} value
 * @param {*} targetLength 默认16位数
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-10-29 14:59:00
 * @Modification history: 
 * @Description: 
 */
export function strArrayToAscll(arr:any) {
  let newArr = [];
  if (arr && arr.length > 0) {
    for (let it of arr) {
      // 判断数字
      if (/^\d+$/.test(it)) {
        if (typeof it === 'string') {
          it = Number(it);
        }
        newArr.push(it);
      } else {
        // 非数字转ASCLL 码
        newArr.push(it.charCodeAt(0));
      }
    }
  }
  return newArr;
}
/**
 * @FunctionName:  获取加密Key
 * @param {*} paiToken
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-12-06 11:15:42
 * @Description:
 */
export function getEncryptionKey(paiToken:any=null) {
  let num = 8;
  if ((window as any).serverConfig.hasOwnProperty('ENCRYPT_KEY_LENGTH') && [16, 24, 32].includes((window as any).serverConfig.ENCRYPT_KEY_LENGTH)) {
    num = (window as any).serverConfig.ENCRYPT_KEY_LENGTH / 2;
  }
  let uuid = guid();
  uuid = uuid.replace(/-/g, '');
  // 密钥长度
  uuid = uuid.substring(0, num);
  uuid = uuid.toUpperCase();
  // 加密Key
  let key:any = null;
  let user_token = '';
  // 有token
  if (paiToken) {
    let access_token = paiToken.access_token.split('.');
    user_token = access_token[2];
    let arrToken = Array.from(user_token);
    let tokenKey = '';
    let keys:any = Array.from(uuid);
    // 转ASCLL 码
    keys = strArrayToAscll(keys);
    for (const it of keys) {
      tokenKey += arrToken[it];
    }
    key = tokenKey + uuid;
  } else {
    let count = 2;
    // 没有token
    if ((window as any).serverConfig.hasOwnProperty('ENCRYPT_KEY_LENGTH') && [16, 24, 32].includes((window as any).serverConfig.ENCRYPT_KEY_LENGTH)) {
      count = (window as any).serverConfig.ENCRYPT_KEY_LENGTH / 8;
    }
    for (let i = 0; i < count; i++) {
      key += uuid;
    }
  }
  return { uuid: uuid, key: key };
}
/**
 * @FunctionName: 加密
 * @param {*} word 加密的字符串
 * @param {*} secretKey 公钥
 * @param {*} encryption_type 加密类型  除了 RSA 其它都走 AES
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-10-29 11:30:29
 * @Modification history:
 * @Description:
 */
export function encrypt(word:any, secretKey:any, encryption_type:any) {
  if (encryption_type === 'RSA') {
    return encryptRSA(word, secretKey);
  } else {
    return encryptAES(word, secretKey);
  }
}
/**
 * @FunctionName:  解密
 * @param {*} word  解密的字符串
 * @param {*} secretKey  公钥
 * @param {*} encryption_type 解密类型 除了 RSA 其它都走 AES
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-10-29 11:29:02
 * @Modification history:
 * @Description:
 */
export function decrypt(word:any, secretKey:any, encryption_type:any) {
  if (encryption_type === 'RSA') {
    return decryptRSA(word, secretKey);
  } else {
    return decryptAES(word, secretKey);
  }
}
/**
 * @FunctionName: 文件下载 路径加密
 * @param {*} url
 * @param {*} rPath
 * @param {*} pUrl
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-12-22 15:59:01
 * @Description:
 */
export function encryptFilePath(url:string, rPath:string, pUrl:string) {
  // 请求加密
  if (!(window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_REQUEST') ||
    ((window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_REQUEST') && 
    (window as any).serverConfig.IS_INTERFACE_ENCRYPTION_REQUEST !== false)) {
    // 全部加密 或者 filter 加密
    if (
      !(window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_ALL') ||
      ((window as any).serverConfig.hasOwnProperty('IS_INTERFACE_ENCRYPTION_ALL') && (window as any).serverConfig.IS_INTERFACE_ENCRYPTION_ALL !== false)
    ) {
      // 过滤不加密接口配置 api/file/download
      let not_encryption = (window as any).serverConfig.NOT_INTERFACE_ENCRYPTION;
      if (not_encryption) {
        not_encryption = not_encryption.split('|');
        for (const key of not_encryption) {
          if (url.indexOf(key) > -1) {
            return url + rPath + pUrl;
          }
        }
      }
      // 设置要加密的服务 file-rest
      let service_encryption = (window as any).serverConfig.IS_SERVICE_ENCRYPTION;
      if (service_encryption) {
        service_encryption = service_encryption.split('|');
        for (const key of service_encryption) {
          if (url.indexOf(key) === -1) {
            return url + rPath + pUrl;
          }
        }
      }
      // 加密等级 1
      if (!(window as any).serverConfig.hasOwnProperty('ENCRYPT_LEVEL') || (window as any).serverConfig.ENCRYPT_LEVEL === 1) {
        // TODO
      }
      // 加密等级 2
      if ((window as any).serverConfig.hasOwnProperty('ENCRYPT_LEVEL') && (window as any).serverConfig.ENCRYPT_LEVEL === 2) {
        // TODO
      }
      // 加密等级 3
      if ((window as any).serverConfig.hasOwnProperty('ENCRYPT_LEVEL') && (window as any).serverConfig.ENCRYPT_LEVEL === 3) {
        let enPrame = getEncryptionKey();
        rPath = encryptionGet(rPath, enPrame);
        return url + '/' + rPath + pUrl + '&d=' + enPrame.uuid;
      }
    }
  }
  return url + rPath + pUrl;
}

/**
 * @FunctionName: 下载文件 api/file/download 配置
 * @param {*} rPath
 * @param {*} pUrl
 * @param {*} enPrame
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-12-22 16:26:20
 * @Description:
 */
export function encryptionGet(rPath:string, enPrame:any) {
  let get_encryption = (window as any).serverConfig.IS_GET_INTERFACE_ENCRYPTION;
  if (get_encryption) {
    get_encryption = get_encryption.split('|');
    if (get_encryption.includes('api/file/download')) {
      if (rPath.substr(0, 1) === '/') {
        rPath = rPath.substr(1, rPath.length);
      }
      rPath = encrypt(rPath, enPrame.key, (window as any).serverConfig.ENCRYPTION_MODE);
      rPath = rPath.replace(/\//g, '|');
      rPath = encodeURIComponent(rPath);
    }
  }
  return rPath;
}
